import { AnyAction } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../../../store'
import { uploadFiles } from '../../../modules/uploadEulaFiles/action'
import { sendResaleAuthorization } from '../../../modules/resaleAuthorization/action'
import { errorLogger, getErrorMessages, updateAppAlert } from '@labrav/common'
import { defaultNow } from '../../../common/utils/dateTimeNow'
import { isEmpty } from 'lodash'
import { AxiosError, AxiosResponse } from 'axios'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { bucketName } from '../../../common/utils/constants'
import type { FileUploadResaleAuthorizationProps } from '../types'

export const fileUploadResaleAuthorization =
  ({
    partnerId,
    productId,
    selectedEulaFiles,
    selectedResellerAgreementFiles,
    saveAsDraft,
    crmOpportunityId,
    crmObjectLink,
  }: FileUploadResaleAuthorizationProps) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      let fileUploads: AnyAction[] = []

      const eulaUploadDispatch = dispatch(
        uploadFiles({
          partnerId,
          productId,
          filesToBeUploaded: selectedEulaFiles,
          assetType: 'eula_files',
          folder: 'reseller_end_customer_eula',
          defaultNow,
          saveAsDraft,
          crmOpportunityId,
          crmObjectLink,
          bucketName,
          showRealFileName: true,
        }) as unknown as AnyAction
      )
      const resellerLicenseUploadDispatch = await dispatch(
        uploadFiles({
          partnerId,
          productId,
          filesToBeUploaded: selectedResellerAgreementFiles,
          assetType: 'eula_files',
          folder: 'reseller_agreement_license',
          defaultNow,
          saveAsDraft,
          crmOpportunityId,
          crmObjectLink,
          bucketName,
          showRealFileName: true,
        }) as unknown as AnyAction
      )
      if (!isEmpty(selectedEulaFiles))
        fileUploads = [...fileUploads, eulaUploadDispatch]

      if (!isEmpty(selectedResellerAgreementFiles))
        fileUploads = [...fileUploads, resellerLicenseUploadDispatch]

      await Promise.all(fileUploads)
        .then(async () => {
          await dispatch(
            sendResaleAuthorization({
              partnerId,
              productId,
              saveAsDraft,
              crmOpportunityId,
              crmObjectLink,
            }) as unknown as AnyAction
          )
        })
        .catch(error => {
          const globalState = getState()
          errorLogger({ globalState })(error as Error)
          throw error
        })
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    }
  }
